module.exports = __webpack_public_path__ + "static/media/Judgement.85b19b17.png";